import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface TransacaoPixModel {
    id: number
    pedidoFormatado: string | null
    nomeServicoFormatado: string
    nomePagador: string | null
    dataCriacao: string | null
    dataEfetivacao: string | null
    nomeSituacao: string | null
    valorBrutoFormatado: string
    valorTaxaFormatado: string
    valorLiquidoFormatado: string
    valorLiquido: number | null
    tipoMovimento: string | null
    entrada: boolean
    estorno: boolean
    estornarHabilitado: boolean
    estabelecimento: string | null
}

export interface GrupoTransferenciaModel {
    pendente: boolean
    identificador: string
    dataExibicao: string
    valorTransferencia: number | null
    valorTransferenciaFormatado: string
    totalVendas: number
    totalVendasFormatado: string
    totalEstornos: number
    totalEstornosFormatado: string
    quantidadeVendas: number
    quantidadeEstornos: number
    componentes: TransacaoPixModel[]
}

export interface ResumoEstabelecimentoModel {
    estabelecimento: string
    totalBrutoFormatado: string
    totalTaxasFormatado: string
    totalEstornosFormatado: string
    totalLiquidoFormatado: string
}

export interface ExtratoPixResponse {
    grupos: GrupoTransferenciaModel[]
    resumo: ResumoEstabelecimentoModel[]
    saldo: string
    saldoNumerico: number
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const obterExtratoDetalhado = async function (
    authorization: string,
    dataInicio: string,
    dataFim: string
): Promise<ExtratoPixResponse | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<ExtratoPixResponse>>(
                `canvi/ObterExtratoDetalhado?dataInicio=${dataInicio}&dataFim=${dataFim}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authorization,
                    },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ExtratoPixResponse>(response, "ObterExtratoDetalhado")
    } catch (error) {
        RegistrarLogErro(error, "ObterExtratoDetalhado", `${dataInicio} - ${dataFim}`)
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const estornarTransacao = async function (
    authorization: string,
    id: number
): Promise<{ mensagem: string } | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<{ mensagem: string }>>(
                `canvi/EstornarTransacao/${id}`,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authorization,
                    },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<{ mensagem: string }>(response, "EstornarTransacao")
    } catch (error) {
        RegistrarLogErro(error, "EstornarTransacao", String(id))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
